import { supabase } from '../lib/supabase';

// CRITICAL FIX: Get effective user ID for all queries
const getEffectiveUserId = () => {
  const impersonationData = localStorage.getItem('admin_impersonation');
  if (impersonationData) {
    const { impersonatedUserId } = JSON.parse(impersonationData);
    return impersonatedUserId;
  }
  return null;
};

// Add this helper function
const toCamelCaseArray = (data) => {
  if (!data) return [];
  return data?.map(item => ({
    id: item?.id,
    userId: item?.user_id,
    baseAmount: item?.base_amount,
    vatPercentage: item?.vat_percentage,
    calculationType: item?.calculation_type,
    grossAmount: item?.gross_amount,
    vatAmount: item?.vat_amount,
    netAmount: item?.net_amount,
    createdAt: item?.created_at,
    updatedAt: item?.updated_at,
  }));
};

export const vatCalculatorService = {
  /**
   * Get all VAT calculations for the authenticated user
   */
  async getCalculations() {
    try {
      const effectiveUserId = getEffectiveUserId();
      
      let query = supabase
        ?.from('vat_calculations')
        ?.select('*')
        ?.order('created_at', { ascending: false });
      
      if (effectiveUserId) {
        query = query?.eq('user_id', effectiveUserId);
      }

      const { data, error } = await query;

      if (error) throw error;
      return toCamelCaseArray(data);
    } catch (error) {
      console.error('Error fetching VAT calculations:', error);
      throw error;
    }
  },

  /**
   * Alias for getCalculations - for backwards compatibility
   */
  async getAll() {
    return this.getCalculations();
  },

  /**
   * Create a new VAT calculation
   */
  async create(calculation) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    // Convert camelCase to snake_case for database
    const { data, error } = await supabase?.from('vat_calculations')?.insert({
        user_id: user?.id,
        base_amount: calculation?.baseAmount,
        vat_percentage: calculation?.vatPercentage,
        calculation_type: calculation?.calculationType,
        gross_amount: calculation?.grossAmount,
        vat_amount: calculation?.vatAmount,
        net_amount: calculation?.netAmount,
      })?.select()?.single();

    if (error) throw error;

    // Convert back to camelCase
    return {
      id: data?.id,
      userId: data?.user_id,
      baseAmount: data?.base_amount,
      vatPercentage: data?.vat_percentage,
      calculationType: data?.calculation_type,
      grossAmount: data?.gross_amount,
      vatAmount: data?.vat_amount,
      netAmount: data?.net_amount,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at,
    };
  },

  /**
   * Delete a VAT calculation
   */
  async delete(id) {
    const { error } = await supabase?.from('vat_calculations')?.delete()?.eq('id', id);

    if (error) throw error;
  },

  /**
   * Delete all VAT calculations for the authenticated user
   */
  async deleteAll() {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { error } = await supabase?.from('vat_calculations')?.delete()?.eq('user_id', user?.id);

    if (error) throw error;
  },
};